import type { LOCALE } from "core/interfaces";

import { getKindLinks } from "~/common/helpers/get-kind-links";
import type { ShopProductsResponseDto } from "~/common/interfaces/dto/shop/shop-products-response.dto";
import type { KindTrimmed } from "~/common/interfaces/kind-trimmed";

export const navigateToItemDetails = (
	locale: LOCALE,
	kinds: KindTrimmed[],
	item: ShopProductsResponseDto
) => {
	const kindLink = getKindLinks(locale, kinds).find(
		({ id }) => id === item.kind.id
	);
	const linkWithItemId = `${kindLink?.link.path}/${item.id}`;

	kindLink && navigateTo(linkWithItemId);
};
